import { render } from "./RichTextInput.vue?vue&type=template&id=0936d316&scoped=true"
import script from "./RichTextInput.vue?vue&type=script&lang=js"
export * from "./RichTextInput.vue?vue&type=script&lang=js"

import "./RichTextInput.vue?vue&type=style&index=0&id=0936d316&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0936d316"]])

export default __exports__